module.exports = __webpack_public_path__ + "static/media/nl.16b7b945.svg";